import React from 'react';
import { X, CheckCircle } from 'lucide-react';
export function BeforeAfterSection() {
  const before = ['Pensás en él todo el día', 'Revisás su vida constantemente', 'Te sentís emocionalmente inestable', 'Volvés aunque sabés que no va'];
  const after = ['Paz mental', 'Claridad emocional', 'Control sobre tus decisiones', 'Amor propio real', 'Cierre definitivo'];
  return <section className="bg-white py-12 md:py-16 px-4" data-id="element-16">
      <div className="max-w-5xl mx-auto" data-id="element-17">
        <h2 className="text-3xl md:text-4xl font-black text-gray-900 mb-10 text-center" data-id="element-18">
          🔄 Antes vs Después
        </h2>

        <div className="grid md:grid-cols-2 gap-6" data-id="element-19">
          <div className="bg-red-50 border-2 border-red-200 rounded-lg p-6 md:p-8" data-id="element-20">
            <h3 className="text-2xl font-black text-red-600 mb-6 flex items-center gap-2" data-id="element-21">
              <X className="w-8 h-8" data-id="element-22" />
              Antes
            </h3>
            <ul className="space-y-4" data-id="element-23">
              {before.map((item, index) => <li key={index} className="flex items-start gap-3" data-id="element-24">
                  <span className="text-red-600 font-bold" data-id="element-25">•</span>
                  <span className="text-gray-800" data-id="element-26">{item}</span>
                </li>)}
            </ul>
          </div>

          <div className="bg-green-50 border-2 border-green-200 rounded-lg p-6 md:p-8" data-id="element-27">
            <h3 className="text-2xl font-black text-green-600 mb-6 flex items-center gap-2" data-id="element-28">
              <CheckCircle className="w-8 h-8" data-id="element-29" />
              Después
            </h3>
            <ul className="space-y-4" data-id="element-30">
              {after.map((item, index) => <li key={index} className="flex items-start gap-3" data-id="element-31">
                  <CheckCircle className="w-5 h-5 text-green-600 flex-shrink-0 mt-0.5" data-id="element-32" />
                  <span className="text-gray-800 font-semibold" data-id="element-33">{item}</span>
                </li>)}
            </ul>
          </div>
        </div>

        <div className="mt-10 bg-purple-900 text-white rounded-lg p-6 md:p-8 text-center" data-id="element-34">
          <h3 className="text-2xl md:text-3xl font-black mb-4" data-id="element-35">
            🧠 Con apoyo psicológico real
          </h3>
          <div className="grid md:grid-cols-3 gap-4 text-left" data-id="element-36">
            <div className="flex items-start gap-2" data-id="element-37">
              <CheckCircle className="w-5 h-5 flex-shrink-0 mt-1" data-id="element-38" />
              <span data-id="element-39">Ejercicios guiados</span>
            </div>
            <div className="flex items-start gap-2" data-id="element-40">
              <CheckCircle className="w-5 h-5 flex-shrink-0 mt-1" data-id="element-41" />
              <span data-id="element-42">Técnicas de desapego emocional</span>
            </div>
            <div className="flex items-start gap-2" data-id="element-43">
              <CheckCircle className="w-5 h-5 flex-shrink-0 mt-1" data-id="element-44" />
              <span data-id="element-45">Reprogramacion mental</span>
            </div>
          </div>
          <p className="mt-6 text-lg" data-id="element-46">
            Es como tener una guía psicológica… pero clara, directa y aplicable.
          </p>
        </div>
      </div>
    </section>;
}